import { Button } from "@/components/ui/button";
import { getUserRoles } from '@/utils/auth';
import { ArrowLeft } from "lucide-react";
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { PLTCPPrintTemplatePage1, PLTCPPrintTemplatePage2 } from './PrintCertificateTemplates/PLTCPPrintTemplate';

const PLTCPCertificatePrintPage = () => {
   const location = useLocation();
   const navigate = useNavigate();
   const certificate = location.state?.certificate;
   const certificateData = location.state?.certificateData;
   const orderOfPayment = location.state?.orderOfPayment;
   const pageNumber = location.state?.pageNumber || 1; // Default to page 1 if not specified

   useEffect(() => {
      if (!certificate || !certificate.pltcpCertificateData) {
         console.error('Invalid certificate data:', certificate);
         toast.error('Invalid certificate data');
         navigate('/personnel/dashboard');
         return;
      }
   }, [certificate, navigate]);

   let check = 0;
   useEffect(() => {
      check++;
      if (location.pathname === '/personnel/pltcp-certificate-print') {
         if (check === 1) {
            toast.info(`Please wait while we print page ${pageNumber} of your certificate...`, { duration: 3000, position: 'top-center' });
         }
         if (check === 1) {
            setTimeout(() => {
               window.print();
            }, 3500);
         }
      } else {
         toast.error('Invalid URL');
         navigate('/personnel/dashboard');
      }
   }, [location.pathname, pageNumber]);

   const handleBack = () => {
      const userRoles = getUserRoles();
      if (userRoles.includes('Technical_Staff')) {
         navigate("/personnel/technical-staff");
      } else {
         navigate("/personnel/dashboard");
      }
   };

   if (!certificate || !certificate.pltcpCertificateData) return null;

   // Choose template based on page number
   const templateContent = pageNumber === 1
      ? PLTCPPrintTemplatePage1({ certificate, certificateData, orderOfPayment })
      : PLTCPPrintTemplatePage2({ certificate, certificateData, orderOfPayment });

   return (
      <div className="print-page bg-white min-h-screen">
         {/* Back Button - will be hidden during print */}
         <div className="fixed top-4 left-4 no-print">
            <Button
               variant="outline"
               onClick={handleBack}
               className="flex items-center gap-2"
            >
               <ArrowLeft className="h-4 w-4" />
               Back
            </Button>
         </div>

         <div
            className="print-content"
            dangerouslySetInnerHTML={{
               __html: templateContent
            }}
         />

         <style>
            {`
              @media print {
                @page {
                  size: A4;
                  margin: 15mm;
                }
                .no-print {
                  display: none !important;
                }
                .print-content {
                  padding: 0;
                  margin: 0;
               }
                body {
                  margin: 0;
                  padding: 0;
                }
              }

              /* Hide scrollbars for all browsers */
              body {
                -ms-overflow-style: none !important; /* IE and Edge */
                scrollbar-width: none !important; /* Firefox */
                overflow: hidden !important;
              }

              body::-webkit-scrollbar {
                display: none !important; /* Chrome, Safari, Opera */
              }

              /* Hide scrollbars for all elements */
              * {
                scrollbar-width: none !important;
                -ms-overflow-style: none !important;
              }

              *::-webkit-scrollbar {
                display: none !important;
              }

              .print-page {
                overflow: hidden !important;
              }

              .print-content {
                overflow: hidden !important;
              }

              html {
                overflow: hidden !important;
              }
            `}
         </style>
      </div>
   );
};

export default PLTCPCertificatePrintPage;